import React from 'react'
import { Show, TextField, DateField } from '@refinedev/antd'
import { useShow } from '@refinedev/core'
import { Typography, List as AntList, Divider, Tag, Image, Space } from 'antd'
import type { Tables } from '@muaa/shared'

type Article = Tables<'articles'>

const { Title, Text } = Typography

export function ArticleShow() {
  const { query } = useShow<Article>()
  const isLoading = query.isLoading
  const record = query.data?.data

  return (
    <Show isLoading={isLoading}>
      {/* ── Header ─────────────────────────────────────────── */}
      <Divider orientation="left">Header</Divider>
      <Title level={5}>Title</Title>
      <TextField value={record?.title ?? '—'} />
      <Title level={5}>Category</Title>
      <TextField value={record?.category ?? '—'} />
      <Title level={5}>Date</Title>
      <TextField value={record?.date ?? '—'} />
      <Title level={5}>Read Time</Title>
      <TextField value={record?.read_time ?? '—'} />

      {/* ── Tags ───────────────────────────────────────────── */}
      <Divider orientation="left">Tags</Divider>
      {record?.tags && record.tags.length > 0 ? (
        <Space wrap>
          {record.tags.map((t) => (
            <Tag key={t} color="gold">
              {t}
            </Tag>
          ))}
        </Space>
      ) : (
        <TextField value="—" />
      )}

      {/* ── Photo ──────────────────────────────────────────── */}
      <Divider orientation="left">Photo</Divider>
      {record?.image_url ? (
        <Image
          src={record.image_url}
          alt={record?.image_label ?? 'hero image'}
          width={260}
          style={{ borderRadius: 8 }}
        />
      ) : (
        <Text type="secondary">No image URL — the app shows the placeholder label below.</Text>
      )}
      <Title level={5} style={{ marginTop: 12 }}>
        Image Label / Caption
      </Title>
      <TextField value={record?.image_label ?? '—'} />

      {/* ── Attribution ────────────────────────────────────── */}
      <Divider orientation="left">Attribution</Divider>
      <Title level={5}>Author Name</Title>
      <TextField value={record?.author_name ?? '—'} />
      <Title level={5}>Author Title</Title>
      <TextField value={record?.author_title ?? '—'} />

      {/* ── Body ───────────────────────────────────────────── */}
      <Divider orientation="left">Body</Divider>
      {Array.isArray(record?.body) && record.body.length > 0 ? (
        <AntList
          dataSource={record.body}
          renderItem={(paragraph: string, index: number) => (
            <AntList.Item key={index} style={{ display: 'block', paddingBottom: 8 }}>
              <Typography.Paragraph style={{ marginBottom: 0 }}>{paragraph}</Typography.Paragraph>
            </AntList.Item>
          )}
          size="small"
          split={false}
        />
      ) : (
        <TextField value="—" />
      )}

      {/* ── Link ───────────────────────────────────────────── */}
      <Divider orientation="left">Link</Divider>
      <Title level={5}>Link Label</Title>
      <TextField value={record?.link_label ?? '—'} />
      <Title level={5}>Link URL</Title>
      <TextField value={record?.link_url ?? '—'} />

      <Divider />
      <Title level={5}>Created</Title>
      {record?.created_at ? (
        <DateField value={record.created_at} format="MMM D, YYYY h:mm A" />
      ) : (
        <TextField value="—" />
      )}
    </Show>
  )
}
